module.exports = __webpack_public_path__ + "static/media/mail.23782afa.svg";